import React from 'react';
import PropTypes from 'prop-types';
import { PartnersArticleContainer }
from '@fuww/library/src/Article';
import Body from '@fuww/library/src/InnerHtmlStyling';
import Headline3 from '@fuww/library/src/Typography/Heading/Headline3';

import Article from '../components/News/Article';
import withApollo from '../lib/apollo';
import { useSiteContext } from '../components/SiteContext';
import throw404 from '../lib/throw404';
import { partners } from '../lib/constants';

const ArticleComponent = ({ body, title }) => (
  <PartnersArticleContainer>
    <Headline3 tag="h1">{title}</Headline3>
    <Body
      dangerouslySetInnerHTML={{ __html: body }}
    />
  </PartnersArticleContainer>
);

ArticleComponent.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

const PartnersPage = () => {
  const { prefix } = useSiteContext();

  const articleId = partners[prefix];

  if (!articleId) return throw404();

  return (
    <Article id={articleId} ArticleComponent={ArticleComponent} />
  );
};

export default withApollo(PartnersPage);
